import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/subscriptions/:subscriptionId/installments`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const subscriptionInstallments = {
  getAll: apiPathFunc(pathBase),
};
